import { useEffect } from 'react';

import { refreshSession } from '../api/client';
import { useSessionStore } from './session-store';

/**
 * Recovers the session from the refresh cookie on first load.
 *
 * The access token is deliberately not persisted, so every reload starts with
 * nothing. Without this the user would be thrown back to the login screen for
 * pressing F5, which is not a security measure, it is an insult.
 *
 * It goes through the shared `refreshSession`, never a refresh of its own: the
 * screens mounting alongside it hit 401s and refresh too, and the rotating
 * refresh token only survives if they all share one request.
 */
export function useRestoreSession(): void {
  const finishRestoring = useSessionStore((state) => state.finishRestoring);

  useEffect(() => {
    void refreshSession()
      .catch(() => false)
      .then((restored) => {
        // No cookie, or one the server no longer honours. Not an error: it is
        // simply somebody who is not signed in.
        if (!restored) {
          finishRestoring();
        }
      });
  }, [finishRestoring]);
}
